import $ from "jquery";
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const swiperInstances = [];

function initVoiceSwipers() {
  // 既存のSwiperをすべて破棄
  swiperInstances.forEach(instance => {
    if (instance && instance.destroy) {
      instance.destroy(true, true);
    }
  });
  swiperInstances.length = 0;

  const windowWidth = window.innerWidth;

  // クラス名が js-voiceSwiper で始まるすべての要素を対象に
  $('[class*="js-voiceSwiper"]').each(function () {
    const $swiperContainer = $(this);
    const slideCount = $swiperContainer.find('.swiper-slide').length;

    // クラスのリセット
    $swiperContainer.removeClass('-inactivePc -inactiveSp');

    // この要素のユニークなクラスを取得（js-voiceSwiper or js-voiceSwiper1, etc）
    const uniqueClass = $swiperContainer.attr('class').split(' ').find(cls => cls.startsWith('js-voiceSwiper'));
    const selector = `.${uniqueClass}`;

    // 共通Swiper設定
    const swiperOptions = {
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      centeredSlides: true,
      loop: true,
      navigation: {
        nextEl: `${selector} .swiper-button-next`,
        prevEl: `${selector} .swiper-button-prev`,
      },
      pagination: {
        clickable: true,
        el: `${selector} .swiper-pagination`,
      },
      slidesPerView: "auto",
      spaceBetween: 0,
    };

    // 初期化条件（PC or SP）
    if (windowWidth >= 768) {
      if (slideCount >= 4) {
        const swiper = new Swiper(selector, swiperOptions);
        swiperInstances.push(swiper);
      } else {
        $swiperContainer.addClass('-inactivePc');
      }
    } else {
      if (slideCount >= 2) {
        const swiper = new Swiper(selector, swiperOptions);
        swiperInstances.push(swiper);
      } else {
        $swiperContainer.addClass('-inactiveSp');
      }
    }
  });
}

// 初期化
$(document).ready(function () {
  initVoiceSwipers();
});

// リサイズ対応（debounceあり）
let resizeTimer;
$(window).on('resize', function () {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    initVoiceSwipers();
  }, 300);
});
